<template>
    <div>
        <div class="centered">
            <b-icon-info-circle font-scale="4"></b-icon-info-circle>
            <span class="you-sure mt-4">Modulele următoare vor fi duplicate:</span>
            <b-form-group>
                <b-form-checkbox-group
                    id="checkbox-group-2"
                    v-model="selected"
                    name="duplicate"
                    @input="saveSelection()"
                >
                    <ul class="mt-2" style="width: 100%; margin-left: 5%">
                        <li><b-form-checkbox value="activities">Activități</b-form-checkbox></li>
                        <li><b-form-checkbox value="objectives">Obiective</b-form-checkbox></li>
                        <li><b-form-checkbox value="acquisitions">Achiziții</b-form-checkbox></li>
                        <li><b-form-checkbox value="business_plan">Plan de afaceri</b-form-checkbox></li>
                        <li><b-form-checkbox value="financial_request">Cerere de finanțare</b-form-checkbox></li>
                    </ul>
                </b-form-checkbox-group>
            </b-form-group>
        </div>
    </div>
</template>

<script>
    import {BIconInfoCircle, BFormCheckboxGroup, BFormGroup, BFormCheckbox} from 'bootstrap-vue';
    export default{
        components:{
            BIconInfoCircle,
            BFormCheckboxGroup,
            BFormGroup, BFormCheckbox
        },
        data() {
            return {
                selected: [],
            }
        },
        methods: {
            saveSelection(){
                this.$emit('selectedSections', this.selected);
            }
        }
    }
</script>

<style scoped>
.centered{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.button-modal{
    font-size: 13px;
}
.flexed{
    display: flex;
    margin-top: 15px;
    width: 100%;
    justify-content: space-evenly;
}
.modal-footer > .btn{
    padding: 3px 10px;
}
.you-sure{
    font-size: 18px;
    font-weight: 600;
}
span, p, svg{
    color: #fff;
}
ul{
    columns: 2;
}
li{
    font-size: 13px;
    color: #fff;
}
</style>
